var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-card agb-data terms-and-notes"},[_vm._t("headline"),_c('div',{staticClass:"inline-text agb-consent",attrs:{"id":"txtAGBText"}},[_c('span',[_vm._t("txtAGBwithLink")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }